import Enumeration from './enum';

/*
 * The possible offer types
 */
const OfferTypeEnum = new Enumeration({
  AUTOMATIC: 'automatically',
  MANUAL: 'manual',
});

export default OfferTypeEnum;
